import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Layout from './components/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Estoque from './pages/Estoque';
import VeiculoDetalhe from './pages/VeiculoDetalhe';
import Clientes from './pages/Clientes';
import Vendas from './pages/Vendas';
import Relatorios from './pages/Relatorios';
import NovaVenda from './pages/NovaVenda';
import Financeiro from './pages/Financeiro';
import Fornecedores from './pages/Fornecedores';
import Usuarios from './pages/Usuarios';
import Perfil from './pages/Perfil';
import CRM from './pages/CRM';

function PrivateRoute({ children, adminOnly = false }) {
  const { usuario, loading } = useAuth();
  if (loading) return <div style={{ color: '#1A3A5C', display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh', fontFamily: "'DM Sans',system-ui,sans-serif" }}>Carregando...</div>;
  if (!usuario) return <Navigate to="/login" />;
  if (adminOnly && usuario.nivel !== 'admin' && usuario.nivel !== 'gerente') return <Navigate to="/" />;
  return <Layout>{children}</Layout>;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
      <Route path="/estoque" element={<PrivateRoute><Estoque /></PrivateRoute>} />
      <Route path="/estoque/:id" element={<PrivateRoute><VeiculoDetalhe /></PrivateRoute>} />
      <Route path="/clientes" element={<PrivateRoute><Clientes /></PrivateRoute>} />
      <Route path="/vendas/nova" element={<PrivateRoute><NovaVenda /></PrivateRoute>} />
      <Route path="/vendas" element={<PrivateRoute><Vendas /></PrivateRoute>} />
      <Route path="/perfil" element={<PrivateRoute><Perfil /></PrivateRoute>} />
      <Route path="/relatorios" element={<PrivateRoute adminOnly><Relatorios /></PrivateRoute>} />
      <Route path="/financeiro" element={<PrivateRoute adminOnly><Financeiro /></PrivateRoute>} />
      <Route path="/fornecedores" element={<PrivateRoute adminOnly><Fornecedores /></PrivateRoute>} />
      <Route path="/usuarios" element={<PrivateRoute adminOnly><Usuarios /></PrivateRoute>} />
      <Route path="/crm" element={<PrivateRoute><CRM /></PrivateRoute>} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRoutes />
      </AuthProvider>
    </BrowserRouter>
  );
}
